import { cityByAirport, distinguishingAirportName } from '@voll-intelligence/domain';

/**
 * O NOME de um aeroporto como a pessoa o lê ao lado do código: a cidade do domain e,
 * quando a cidade tem mais de um aeroporto, o nome dele ("Dallas — Love Field",
 * "São Paulo — Guarulhos"; #4157). O fornecedor manda a CIDADE em caixa alta no
 * campo de nome ("DALLAS"), e "DAL DALLAS" não dizia qual dos dois aeroportos era.
 * Código que o domain não conhece cai no `fallback` do fornecedor; sem nenhum dos
 * dois, `undefined` (o chamador mostra só o código).
 */
export function airportPlaceName(iata: string, fallback?: string): string | undefined {
  const city = cityByAirport(iata);
  if (city === null) return fallback || undefined;
  const airport = distinguishingAirportName(iata);
  return airport ? `${city} — ${airport}` : city;
}
